import React from 'react';
import PropTypes from 'prop-types';
import getClientDimensions from '../../../../../../../../../../../shared/lib/get-client-dimensions/index';
import componentBase from '../../../../../../../../../../../src/lib/component-base';

const icon = require('../../../../../../../../../../../static/images/plane-orange-vertical.svg');
const xwingIcon = require('../../../../../../../../../../../static/images/xwing/Xwing-Topdown-vertical.svg');

const startColorGradient = 'rgba(129, 162, 202, 0.5)';
const startColorGradientHex = '#8081A2CA';
const endColorGradient = 'rgba(0, 0, 0, 1)';
const endColorGradientHex = '#00000000';

let resizeTimeout;
let Raphael;

const resizeThrottlerFunctionGenerator = actualResizeHandler => () => {
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();
    }, 66);
  }
};

@componentBase('FlightMiniTrackerBearing')
export default class FlightMiniTrackerBearing extends React.Component {
  static propTypes = {
    currentBearing: PropTypes.number,
    currentHeading: PropTypes.number,
    currentDay: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    this._adjustGraphOnResize = this._adjustGraphOnResize.bind(this);

    this.muiDefaultProps = {
      topStyle: {
        padding: '0',
        height: 'inherit',
        background: `-webkit-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Safari 5.1 to 6.0 */
        background: `-o-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Opera 11.1 to 12.0 */
        background: `-moz-linear-gradient(${startColorGradient}, ${endColorGradient})`, /* For Firefox 3.6 to 15 */
        background: `filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=${startColorGradientHex}, endColorstr=${endColorGradientHex})`, /* IE */
        background: `linear-gradient(${startColorGradient}, ${endColorGradient})`, /* Standard syntax */
      },
    };
  }

  componentDidMount() {
    Raphael = require('raphael');
    this.resizeListener = resizeThrottlerFunctionGenerator(this._adjustGraphOnResize);
    window.addEventListener('resize', this.resizeListener);
    this._adjustGraphOnResize();
  }

  componentWillReceiveProps() {
    this._adjustGraphOnResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get planeIcon() {
    if (this.props.currentDay === 'May 04') {
      return xwingIcon;
    }

    return icon;
  }

  _adjustGraphOnResize() {
    if (this.props.currentHeading) {
      this._clearGraph();
      this._drawGraph();
    }
  }

  _clearGraph() {
    if (this.paper) {
      this.paper.clear();
    }
  }

  _drawGraph() {
    const [xWidth, xHeight] = getClientDimensions(document, 'bearingGraph');

    this.paper = this.paper || Raphael(this.refs.bearingGraph, '100%', xHeight); // eslint-disable-line
    this.paper.circle(xWidth / 2, xHeight / 2, xHeight / 2 - 15).attr({
      stroke: '#FFFFFF',
      'stroke-width': 2,
    });

    // uncomment 'degLineTEST' to view heading as a red line...
    //  const degLineTEST = this.paper.path(`M${xWidth / 2}, 15, L${xWidth / 2}, ${xHeight / 2}`)
    //    .attr('stroke', 'rgba(255, 0, 0, 0.6)')
    //    .attr('stroke-width', '2');
    //  degLineTEST.rotate(this.props.currentHeading, xWidth / 2, xHeight / 2);

    const degLine1 = this.paper.path(`M${xWidth / 2}, 15, L${xWidth / 2}, ${30}`)
      .attr('stroke', '#FF9600')
      .attr('stroke-width', '1')
      .attr('visibility', 'hidden');
    const degLine2 = this.paper.path(`M${xWidth / 2}, 3, L${xWidth / 2}, ${27}`)
      .attr('stroke', '#FF9600')
      .attr('stroke-width', '4')
      .attr('visibility', 'hidden');
    const degLine3 = this.paper.path(`M${xWidth / 2}, 3, L${xWidth / 2}, ${27}`)
      .attr('stroke', '#FF9600')
      .attr('stroke-width', '4')
      .attr('visibility', 'hidden');

    const plane = this.paper.image(this.planeIcon, xWidth / 2 - 15, 0, 30, 30)
      .attr('visibility', 'hidden');

    degLine2.rotate(90, xWidth / 2, xHeight / 2);
    degLine3.rotate(270, xWidth / 2, xHeight / 2);
    plane.rotate(this.props.currentHeading, xWidth / 2, xHeight / 2);

    // make things visible
    degLine1.attr('visibility', 'visible');
    degLine2.attr('visibility', 'visible');
    degLine3.attr('visibility', 'visible');
    plane.attr('visibility', 'visible');
  }

  _getBearing() {
    if (this.props.currentBearing) {
      return this.props.currentBearing.toFixed(1);
    }

    return '--';
  }

  _getHeading() {
    if (this.props.currentHeading) {
      const heading = this.props.currentHeading.toFixed(0);

      if (heading < 10) {
        return `00${heading}`;
      }

      if (heading < 100) {
        return `0${heading}`;
      }

      return heading;
    }

    return '--';
  }

  render() {
    // console.log('[FlightMiniTrackerBearing] render : props', this.props);

    return (
      <div style={this.muiDefaultProps.topStyle}>
        <div id='bearingGraph' ref='bearingGraph' style={{ position: 'absolute', height: 'inherit', width: '100%' }} />
        <div className='col-xs-12 col-sm-12 col-md-12' style={{ padding: '0', height: '50%' }}>
          <div
            className='col-xs-12 col-sm-12 col-md-12'
            style={{
 position: 'absolute', padding: '0', bottom: '0', textAlign: 'center',
}}
          >
            <span style={{ fontSize: '12pt' }}>Heading</span>
          </div>
        </div>
        <div className='col-xs-12 col-sm-12 col-md-12' style={{ padding: '0', height: '50%' }}>
          <div
            className='col-xs-12 col-sm-12 col-md-12'
            style={{
 position: 'absolute', padding: '0', top: '0', textAlign: 'center',
}}
          >
            <span style={{ fontSize: '16pt', fontWeight: 'bold', color: '#FF9600' }}>{ this._getHeading() }</span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/children/FlightMiniTracker/children/FlightMiniTrackerBearing.js